import { Button, Space } from "antd";
// import "../../assets/styles/banks.css"
// import { Popconfirm, Button } from "antd";
import { Tooltip, Typography } from "antd";
// import { EditOutlined, QuestionCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import { TagPurchaseOrderStatus } from "../../../components/badge-and-tag/ERP";
import { TagsCreateBy } from "../../../components/badge-and-tag/";
import {
  EditableRow,
  EditableCell,
} from "../../../components/table/TableEditAble";
import dayjs from "dayjs";
import { EditOutlined, EyeOutlined, PrinterOutlined } from "@ant-design/icons";
import { formatMoney, BACKEND_URL_MAIN } from "../../../utils/util";
const { Link } = Typography;
// import { docLinkRender } from "../../../components/table/DocLink";
const calTotalDiscount = (rec) => {
  const total = Number(rec?.qty || 0) * Number(rec?.price || 0);
  return total - Number(rec?.discount || 0);
};
/** export component for edit table */
export const componentsEditable = {
  body: { row: EditableRow, cell: EditableCell },
};


/** get sample column */
export const accessColumn = ({
  handleEdit,
  handleDelete,
  handleView,
  handlePrint,
  handleCloseAttach,
}) => [
  {
    title: "รหัสใบสั่งซื้อ",
    key: "pocode",
    dataIndex: "pocode",
    align: "left",
    sorter: (a, b) => a.pocode.localeCompare(b.pocode),
    width: 140,
    render: (text, record) => (
      <Link onClick={() => handleView(record)}>{text}</Link>
    )
  },
  {
    title: "วันที่ใบสั่งซื้อ",
    dataIndex: "podate",
    key: "podate",
    width: 140,
    sorter: (a, b) => a.podate.localeCompare(b.podate),
    render: (v) => dayjs(v).format("DD/MM/YYYY"),
  },
  {
    title: "รหัสลูกค้า",
    dataIndex: "supcode",
    key: "supcode",
    width: 120,
    sorter: (a, b) => a.supcode.localeCompare(b.supcode),
  },
  {
    title: "ชื่อลูกค้า",
    dataIndex: "supname",
    key: "supname",
    sorter: (a, b) => a.supname.localeCompare(b.supname),
    ellipsis: {
      showTitle: false,
    },
    render: (v) => (
      <Tooltip placement="topLeft" title={v}>
        {v}
      </Tooltip>
    ),
  },
  {
    title: "สถานะ",
    dataIndex: "doc_status",
    key: "doc_status",
    width: "13%",
    sorter: (a, b) => a.doc_status.localeCompare(b.doc_status),
    sortDirections: ["descend", "ascend"],
    render: (data) => <TagPurchaseOrderStatus result={data} />,
  },
  {
    title: "จำนวนค้างรับ",
    dataIndex: "remain_qty",
    key: "remain_qty",
    width: "10%",
    align: "right",
    className: "!pe-3",
    sorter: (a, b) => Number(a.remain_qty || 0) - Number(b.remain_qty || 0),
    render: (v) =>
      Number(v || 0) > 0 ? (
        <span style={{ color: "#cf1322", fontWeight: 600 }}>
          {formatMoney(Number(v || 0), 2, 2)}
        </span>
      ) : (
        <span style={{ color: "#389e0d" }}>-</span>
      ),
  },
  {
    title: "จัดทำโดย",
    dataIndex: "created_name",
    key: "created_name",
    sorter: (a, b) => a.created_name.localeCompare(b.created_name),
    width: "15%",
    ellipsis: {
      showTitle: false,
    },
    render: (data, role) => <TagsCreateBy result={data} role={role} />,
  },
  {
    title: "Action",
    key: "operation",
    fixed: "right",
    width: 130,
    render: (text, record) => (
      <Space>
        <Tooltip title="ดูข้อมูลใบสั่งซื้อ">
          <Button
            icon={<EyeOutlined />}
            className="bn-info-outline"
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={(e) => handleView(record)}
            size="small"
          />
        </Tooltip>
        <Button
          icon={<EditOutlined />}
          className="bn-primary-outline"
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={(e) => handleEdit(record)}
          size="small"
        />

        {/* <Popconfirm 
          placement="topRight"
          title="Sure to delete?"  
          description="Are you sure to delete this packaging?"
          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
          onConfirm={() => handleDelete(record)}
        >
          <Button
            icon={<DeleteOutlined />}
            danger
            style={{ cursor: "pointer", display: 'flex', alignItems: 'center', justifyContent: 'center' }} 
            size="small"
          />
        </Popconfirm> */}
        <Button
          icon={<PrinterOutlined />}
          className='bn-warning-outline'
          style={{ cursor: "pointer", display: 'flex', alignItems: 'center', justifyContent: 'center'}}
          onClick={(e) => handlePrint(record) }
          size="small"
        />
      </Space>
    ),
  },
];

export const productColumn = ({ handleAction }, optionsItems) => [
  {
    title: "#",
    dataIndex: "ind",
    key: "ind",
    align: "center",
    width: 42,
    render: (im, rc, index) => <>{index + 1}</>,
  },
  {
    title: "รหัสสินค้า",
    dataIndex: "stcode",
    key: "stcode",
    width: 90,
    align: "center",
    ellipsis: true,
  },
  {
    title: "ชื่อสินค้า",
    dataIndex: "stname",
    key: "stname",
    align: "left",
    ellipsis: true,
  },
  /* คอลัมน์ "ชนิด" (typename) เอาออกจากตารางแล้ว
     ค่ายังถูกเก็บและส่งไปบันทึกตามปกติ แค่ไม่แสดงในหน้าจอ */
  {
    title: "รูปแบบ",
    dataIndex: "purchase_type",
    key: "purchase_type",
    align: "center",
    width: 80,
    render: (v) => (v === "LOT" ? "เป็น MOQ" : "ตามจำนวน"),
  },
  {
    title: "MOQ",
    dataIndex: "lot_size",
    key: "lot_size",
    align: "center",
    width: 110,
    editable: (record) => record?.purchase_type === "LOT",
    type: "modal-select",
    render: (v, record) => {
      if (record?.purchase_type !== "LOT") return "-";
      const lot = (record?.lots || []).find(
        (l) => Number(l.lot_size) === Number(v)
      );
      return lot
        ? `${lot.lot_name ? lot.lot_name + " " : ""}${lot.lot_size} x ${lot.lot_price}`
        : "เลือก MOQ";
    },
  },
  {
    title: "จำนวน",
    dataIndex: "qty",
    key: "qty",
    width: 120,
    align: "right",
    className: "!pe-2",
    editable: true,
    required: true,
    type: "number",
    render: (_, rec) => <>{formatMoney(Number(rec?.qty || 0), 2, 2)}</>,
  },
  {
    title: "ราคา/หน่วย",
    dataIndex: "price",
    key: "price",
    width: 88,
    align: "right",
    className: "!pe-2",
    editable: true,
    required: true,
    type: "number",
    render: (_, rec) => <>{formatMoney(Number(rec?.price || 0), 2, 2)}</>,
  },
  {
    title: "หน่วย",
    dataIndex: "unit",
    key: "unit",
    align: "right",
    width: 78,
    editable: true,
    type: "select",
    optionsItems,
    render: (v) => {
      return optionsItems?.find((f) => f.value === v)?.label;
    },
  },
  {
    title: "ส่วนลด",
    dataIndex: "discount",
    key: "discount",
    width: 120,
    align: "right",
    className: "!pe-2",
    editable: true,
    type: "number",
    render: (_, rec) => <>{formatMoney(Number(rec?.discount || 0), 2, 2)}</>,
  },
  {
    title: "รวม",
    dataIndex: "total",
    key: "total",
    width: 95,
    align: "right",
    className: "!pe-2",
    render: (_, rec) => <>{formatMoney(calTotalDiscount(rec), 2, 2)}</>,
  },
  {
    title: "",
    align: "center",
    key: "operation",
    dataIndex: "operation",
    render: (_, record, idx) => handleAction(record),
    width: 80,
    fixed: "right",
  },
];

/* ============================================================
   คอลัมน์ตารางรายการสินค้าสำหรับ "หน้าแสดงข้อมูล" (อ่านอย่างเดียว)
   แยกจาก productColumn เพราะตัวนั้นมีเซลล์แก้ไขได้กับปุ่มลบ
   ซึ่งไม่ควรโผล่ในหน้าดูข้อมูล
============================================================ */
export const productColumnView = (optionsItems = []) => [
  {
    title: "#",
    dataIndex: "ind",
    key: "ind",
    align: "center",
    width: 46,
    render: (_v, _rc, index) => index + 1,
  },
  {
    title: "รหัสสินค้า",
    dataIndex: "stcode",
    key: "stcode",
    width: 110,
    align: "center",
  },
  {
    title: "ชื่อสินค้า",
    dataIndex: "stname",
    key: "stname",
    align: "left",
  },
  {
    title: "รูปแบบ",
    dataIndex: "purchase_type",
    key: "purchase_type",
    align: "center",
    width: 90,
    render: (v) => (v === "LOT" ? "เป็น MOQ" : "ตามจำนวน"),
  },
  {
    title: "MOQ",
    dataIndex: "lot_size",
    key: "lot_size",
    align: "center",
    width: 110,
    render: (v, record) => {
      if (record?.purchase_type !== "LOT") return "-";
      const lot = (record?.lots || []).find(
        (l) => Number(l.lot_size) === Number(v)
      );
      return lot
        ? `${lot.lot_name ? lot.lot_name + " " : ""}${lot.lot_size} x ${lot.lot_price}`
        : v || "-";
    },
  },
  {
    title: "จำนวนที่สั่ง",
    dataIndex: "qty",
    key: "qty",
    width: 110,
    align: "right",
    className: "!pe-3",
    render: (v) => formatMoney(Number(v || 0), 2),
  },
  {
    title: "รับแล้ว",
    dataIndex: "recamount",
    key: "recamount",
    width: 100,
    align: "right",
    className: "!pe-3",
    render: (v) => formatMoney(Number(v || 0), 2),
  },
  {
    /* ค้างรับ = จำนวนที่สั่ง - จำนวนที่รับแล้ว (ติดลบ = รับเกิน) */
    title: "ค้างรับ",
    dataIndex: "remain",
    key: "remain",
    width: 100,
    align: "right",
    className: "!pe-3",
    render: (_v, rec) => {
      const remain = Number(rec?.qty || 0) - Number(rec?.recamount || 0);
      if (remain > 0)
        return (
          <span style={{ color: "#cf1322", fontWeight: 600 }}>
            {formatMoney(remain, 2)}
          </span>
        );
      return <span style={{ color: "#389e0d" }}>-</span>;
    },
  },
  {
    title: "ราคา/หน่วย",
    dataIndex: "price",
    key: "price",
    width: 100,
    align: "right",
    className: "!pe-3",
    render: (v) => formatMoney(Number(v || 0), 2),
  },
  {
    title: "หน่วย",
    dataIndex: "unit",
    key: "unit",
    align: "center",
    width: 80,
    render: (v) => optionsItems?.find((f) => f.value === v)?.label ?? v,
  },
  {
    title: "ส่วนลด",
    dataIndex: "discount",
    key: "discount",
    width: 100,
    align: "right",
    className: "!pe-3",
    render: (v) => formatMoney(Number(v || 0), 2),
  },
  {
    title: "รวม",
    dataIndex: "total",
    key: "total",
    width: 110,
    align: "right",
    className: "!pe-3",
    render: (_v, rec) => formatMoney(calTotalDiscount(rec), 2),
  },
];

export const columnsParametersEditable = (
  handleSave,
  optionsItems,
  { handleAction, modalSelect }
) => {
  const col = productColumn({ handleAction }, optionsItems);
  return col.map((col, ind) => {
    if (!col.editable) return col;

    return {
      ...col,
      onCell: (record) => {
        const editable =
          typeof col.editable === "function"
            ? col.editable(record)
            : col.editable;
        const itemsOptions =
          typeof col.optionsItems === "function"
            ? col.optionsItems(record)
            : col.optionsItems || optionsItems;
        return {
          record,
          editable,
          dataIndex: col.dataIndex,
          title: col.title,
          // required: !!col?.required,
          type: col?.type || "input",
          handleSave,
          optionsItems: itemsOptions,
          modalSelect,
        };
      },
    };
  });
};
export const purchaseorderForm = {
  pocode: null,
  podate: null,
  supcode: null,
  supname: null,
  deldate: null,
  contact: null,
  supcontact: null,
  supaddress: null,
  tel: null,
  ship_to: null,
  remark: null,
  total_price: 0,
  vat: 7,
  grand_total_price: 0,
};

export const purchaseorderDetailForm = {
  pocode: null,
  stcode: null,
  stname: null,
  discount: 0,
  qty: 0,
  price: 0,
  unit: null,
};
